import React from 'react';
import styles from './ourValuesView.module.scss';
import { cx } from '@emotion/css';
import { SquaredImageComponent } from '@modules/services/Components';

type Props = {
  image_url: string;
  alt: string;
  header: string;
  description: any;
};

const SingleCoreValue = ({ image_url, alt, header, description }: Props) => {
  return (
    <div className={styles.our_values_single_item}>
      <div className={cx(styles.our_values_image_container, styles.root)}>
        <SquaredImageComponent
          src={image_url}
          alt={alt}
          width="90"
          height="90"
          className={styles.founders_view}
        />
      </div>
      <div className={styles.our_values_description_container}>
        <h5 className={cx(styles.our_values_description_header, styles.h5)}>
          {header}
        </h5>
        {description}
      </div>
    </div>
  );
};
export const OurValuesView = () => {
  const valuesItems = [
    {
      image: '/images/about-us/our_values/Excellence.webp',
      alt: 'Excellence icon',
      header: 'Excellence',
      description: (
        <p className={cx(styles.our_values_description_subtitle, styles.p)}>
          We deliver superior workmanship through fully qualified, insured{' '}
          professionals who treat every job as if it were their own home. Good{' '}
          enough isn't good enough - we never cut corners.
        </p>
      ),
    },
    {
      header: 'Trust & Transparency',
      image: '/images/about-us/our_values/Trust.webp',
      description: (
        <p className={cx(styles.our_values_description_subtitle, styles.p)}>
          We do what we say we'll do, when we say we'll do it. Our pricing is{' '}
          clear, our quotes are honoured, and our 12-month guarantee backs every
          job. No hidden fees, no surprises.
        </p>
      ),
      alt: 'Trush icon',
    },
    {
      header: 'Proactive Communication',
      image: '/images/about-us/our_values/Communication.webp',
      alt: 'Proactive icon',
      description: (
        <p className={cx(styles.our_values_description_subtitle, styles.p)}>
          You'll always know what's happening with your property. From booking
          to completion, we keep you informed and provide honest advice about
          your property's needs.
        </p>
      ),
    },
    {
      image: '/images/about-us/our_values/Reliability.webp',
      header: 'Reliability',
      alt: 'Reliability icon',
      description: (
        <p className={cx(styles.our_values_description_subtitle, styles.p)}>
          We respect your time with quick responses and streamlined service.{' '}
          When we set an appointment, we show up. When we start a job, we finish
          it right the first time.
        </p>
      ),
    },
    {
      image: '/images/about-us/our_values/Accountability.webp',
      header: 'Accountability',
      alt: 'Accountability icon',
      description: (
        <p className={cx(styles.our_values_description_subtitle, styles.p)}>
          We don't just fix what's broken - we prevent future issues and find{' '}
          smarter solutions. If something's not right, we make it right,
          guaranteed.
        </p>
      ),
    },
  ];
  return (
    <section className={styles.about_us}>
      <div className={styles.root}>
        <div className={styles.about_us_card_block}>
          <div className={styles.container}>
            <div className={styles.inner_section}>
              <div className={styles.heading_wrapers}>
                <h2 className={cx(styles.site_title, styles.h2)}>Our Values</h2>
                <p className={cx(styles.heading_wrapers_content, styles.p)}>
                  Property maintenance isn’t just about fixing things – it’s
                  about building trust and making your life easier. These values
                  guide everything we do, from picking up the phone to{' '}
                  completing your job:
                </p>
              </div>
              <div className={styles.our_values_list}>
                {valuesItems.map((valueItem, index) => {
                  return (
                    <SingleCoreValue
                      key={index}
                      image_url={valueItem.image}
                      alt={valueItem.alt}
                      description={valueItem.description}
                      header={valueItem.header}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
